<template>
	<!-- 视频详情页 -->
	<div @click="goImage" class="grid-item">
		<div class="SMVIL_">
			<img :src="message.showImage" />
		</div>
	</div>
</template>

<script setup>
import {
	ref
} from 'vue';
import {
	useRouter
} from "vue-router";
// import { Axios } from "../../assets/js/ls_com_axios.js";
const router = useRouter();
const newData = defineProps({
	message: {
		type: Object, //类型字符串
	},
});
const goImage = function () {
	router.push({
		path: "/ShadowMaterialVideoImage",
		query: {
			id: newData.message.materialId,
		},
	});
};
</script>

<style scoped>
.SMVIL_ {
	/* aspect-ratio: 4 / 3; */
	/* display: flex; */
	/* justify-content: center; */

}

.SMVIL_>img {
	/* min-width: 100%; */
	/* min-height: 100%; */
}

.grid-item img {
	display: block;
	width: 100%;
	height: auto;
	/* 保持图片的宽高比 */
}

.grid-item {
	overflow: hidden;
	/* 防止图片溢出 */
}</style>